import React, { memo } from 'react'

const Shop = () => {
  return (
    <div>
      Shop...
    </div>
  )
}

export default memo(Shop)
